import { useState } from 'react'
import { getIcon } from '../../hooks/useIcons.jsx'

const AccordionItem = ({ title, children, isOpen, onToggle, icon }) => {
  return (
    <div className="border border-border/50 rounded-lg overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 text-left bg-card hover:bg-muted/20 transition-colors duration-200 flex items-center justify-between"
      >
        <div className="flex items-center">
          {icon && <span className="mr-3 text-xl">{icon}</span>}
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        </div>
        <span className={`transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
          {getIcon('ChevronDown', 20)}
        </span>
      </button>
      <div className={`transition-all duration-200 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
        <div className="px-6 py-4 bg-muted/10 border-t border-border/30">
          <div className="text-muted-foreground leading-relaxed">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

const Accordion = ({ items, allowMultiple = false }) => {
  const [openItems, setOpenItems] = useState(new Set())

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems)
    
    if (allowMultiple) {
      if (newOpenItems.has(index)) {
        newOpenItems.delete(index)
      } else {
        newOpenItems.add(index)
      }
    } else {
      if (newOpenItems.has(index)) {
        newOpenItems.clear()
      } else {
        newOpenItems.clear()
        newOpenItems.add(index)
      }
    }
    
    setOpenItems(newOpenItems)
  }

  return (
    <div className="space-y-4">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          icon={item.icon}
          isOpen={openItems.has(index)}
          onToggle={() => toggleItem(index)}
        >
          {typeof item.content === 'string' 
            ? item.content.split('\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  {idx < item.content.split('\n').length - 1 && <br />}
                </span>
              ))
            : item.content
          }
        </AccordionItem>
      ))}
    </div>
  )
}

export default Accordion